import { render, staticRenderFns } from "./batch_ship_dialog.vue?vue&type=template&id=b3d66a74&scoped=true"
import script from "./batch_ship_dialog.vue?vue&type=script&lang=js"
export * from "./batch_ship_dialog.vue?vue&type=script&lang=js"
import style0 from "./batch_ship_dialog.vue?vue&type=style&index=0&id=b3d66a74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d66a74",
  null
  
)

export default component.exports